import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { AlertTriangle, FileSpreadsheet, Unplug, BarChart3, PackageX } from 'lucide-react';
const problems = [{
  icon: Unplug,
  text: 'Insellösungen ohne Verbindung'
}, {
  icon: FileSpreadsheet,
  text: 'Excel-Listen als kritische Datenbasis'
}, {
  icon: AlertTriangle,
  text: 'Medienbrüche im täglichen Ablauf'
}, {
  icon: BarChart3,
  text: 'Unübersichtliche Produktions- & Prozessdaten'
}, {
  icon: PackageX,
  text: 'Standardsoftware passt nicht zu realen Abläufen'
}];
export function ProblemSlide() {
  return <SlideWrapper className="bg-bg-alt" data-id="element-158">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center h-full" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-160">
          <h2 className="text-5xl font-bold text-primary mb-6" data-id="element-161">
            Die Herausforderung
          </h2>
          <p className="text-xl text-text-secondary mb-8" data-id="element-162">
            Viele Industrieunternehmen kämpfen täglich mit ineffizienten
            Strukturen, die das Wachstum bremsen.
          </p>
          <div className="h-1 w-32 bg-red-500 rounded-full" data-id="element-163" />
        </motion.div>

        <div className="space-y-4" data-id="element-164">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + index * 0.1,
          duration: 0.5
        }} className="flex items-center p-5 bg-white rounded-xl shadow-sm border-l-4 border-red-500" data-id="element-165">
              <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center mr-4 shrink-0" data-id="element-166">
                <item.icon className="w-5 h-5 text-red-500" data-id="element-167" />
              </div>
              <span className="text-lg font-medium text-primary" data-id="element-168">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </SlideWrapper>;
}